import { render, staticRenderFns } from "./shoppe-level.vue?vue&type=template&id=36d9d434&scoped=true"
import script from "./shoppe-level.vue?vue&type=script&lang=js"
export * from "./shoppe-level.vue?vue&type=script&lang=js"
import style0 from "./shoppe-level.vue?vue&type=style&index=0&id=36d9d434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9d434",
  null
  
)

export default component.exports